import React from 'react';
import { useApp } from '../context/PetParksContext';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { Badge } from './ui/badge';

export const PetSelector: React.FC<{ compact?: boolean }> = ({
  compact = false,
}) => {
  const { pets, selectedPet, setSelectedPet, t } = useApp();

  return (
    <div className="w-full min-w-0">
      <Select
        value={selectedPet?.id || ''}
        onValueChange={(value) => {
          const pet = pets.find((p) => p.id === value);
          setSelectedPet(pet || null);
        }}
      >
        <SelectTrigger className="w-full min-w-0 bg-card">
          <SelectValue placeholder={t('selectPet')} />
        </SelectTrigger>
        <SelectContent>
          {pets.length === 0 ? (
            <div className="p-4 text-center text-sm text-muted-foreground">
              {t('noPets')}
            </div>
          ) : (
            pets.map((pet) => (
              <SelectItem key={pet.id} value={pet.id}>
                <div className="flex items-center gap-2">
                  <span className="font-medium">{pet.name}</span>
                  {!compact && (
                    <Badge variant="secondary" className="text-xs">
                      {pet.breed}
                    </Badge>
                  )}
                </div>
              </SelectItem>
            ))
          )}
        </SelectContent>
      </Select>

      {selectedPet && !compact && (
        <div className="mt-2 flex flex-wrap gap-1.5">
          <Badge variant="outline" className="text-xs">
            {t(selectedPet.size)}
          </Badge>
          <Badge variant="outline" className="text-xs">
            {selectedPet.energy === 'low' && t('lowEnergy')}
            {selectedPet.energy === 'medium' && t('mediumEnergy')}
            {selectedPet.energy === 'high' && t('highEnergy')}
          </Badge>
          <Badge variant="outline" className="text-xs">
            {t(selectedPet.temperament)}
          </Badge>
          {selectedPet.specialNeeds.map((need) => (
            <Badge key={need} variant="outline" className="text-xs">
              {t(need)}
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
};
